/** Perfil estendido do usuário comerciante/lojista (telefone, pix, cpf). */
export interface ComercioProfile {
  userId: string;
  name: string;
  phone?: string;
  pix?: string;
  cpfDocument?: string; // Base64 ou URL do anexo
}

const KEY_COMERCIO_PROFILES = 'naviex-admin-comercio-profiles';

function loadJson<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : fallback;
  } catch {
    return fallback;
  }
}

function saveJson(key: string, value: unknown): void {
  localStorage.setItem(key, JSON.stringify(value));
}

export function getComercioProfiles(): Record<string, ComercioProfile> {
  return loadJson<Record<string, ComercioProfile>>(KEY_COMERCIO_PROFILES, {});
}

export function getComercioProfile(userId: string): ComercioProfile | null {
  return getComercioProfiles()[userId] ?? null;
}

export function saveComercioProfile(profile: ComercioProfile): void {
  const all = getComercioProfiles();
  all[profile.userId] = profile;
  saveJson(KEY_COMERCIO_PROFILES, all);
}
